// extracted by mini-css-extract-plugin
module.exports = {"hero-priority":"hero-priority-multi-author-m__hero-priority__3C4HD"};